import { render, staticRenderFns } from "./veStuAssocActivityApply.vue?vue&type=template&id=d0f6e6bc&scoped=true"
import script from "./veStuAssocActivityApply.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f6e6bc",
  null
  
)

export default component.exports